// extracted by mini-css-extract-plugin
export default {"desc":"doc-info-bar_desc__LUTbe","toolbar":"doc-info-bar_toolbar__PAVrV","childrenContainer":"doc-info-bar_childrenContainer__anQZw","menuItem":"doc-info-bar_menuItem__iMcxt"};